export default "__VITE_ASSET__BPn_Bri9__"